import { createContext, useState } from "react";

export const UnregisteredEmailContext = createContext({
  openUnregisteredEmailModal: false,
  setOpenUnregisteredEmailModal: () => false,
});

export const UnregisteredEmailProvider = ({ children }) => {
  const [openUnregisteredEmailModal, setOpenUnregisteredEmailModal] =
    useState(false);
  const value = { openUnregisteredEmailModal, setOpenUnregisteredEmailModal };
  return (
    <UnregisteredEmailContext.Provider value={value}>
      {children}
    </UnregisteredEmailContext.Provider>
  );
};
